module.exports = __webpack_public_path__ + "img/galery-palm-x6-plus-2-zoom.bed8d326.png";